import type { HTMLAttributes, ReactNode } from 'react'
import styles from './Typography.module.css'

export interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  /* 1 = page title, 2 = section, 3 = sub-section. Sets both size and tag. */
  level?: 1 | 2 | 3
  align?: 'left' | 'center'
  children: ReactNode
}

export function Heading({ level = 1, align = 'left', className, children, ...rest }: HeadingProps) {
  const Tag = `h${level}` as const
  const cls = [styles.heading, styles[`h${level}`], align === 'center' && styles.alignCenter, className]
    .filter(Boolean).join(' ')
  return <Tag className={cls} {...rest}>{children}</Tag>
}
